var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-emptyFavorite" }, [
    _c("div", { staticClass: "m-emptyState m-emptyState--large" }, [
      _c("img", {
        staticClass: "m-emptyState_image",
        attrs: {
          src: require("icon/empty-state/circle-search-love.svg"),
          alt: "poste indicador",
          title: "endereco não encontrado",
        },
      }),
      _vm._v(" "),
      _c("p", { staticClass: "m-emptyState_title" }, [
        _vm._v(
          "Ops, nenhum fornecedor foi favoritado nesta especialidade ou região"
        ),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "m-emptyState_paragraph" }, [
        _vm._v(
          "Para favoritar fornecedores, volte para a lista e clique nos corações ❤️"
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "c-emptyFavorite_grid" }, [
      _c(
        "button",
        {
          staticClass: "c-emptyFavorite_buttonLight",
          on: {
            click: function ($event) {
              return _vm.filterAll()
            },
          },
        },
        [_vm._v("Voltar para lista completa")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "c-emptyFavorite_buttonMain",
          attrs: { href: _vm.userAccount.favorite },
        },
        [_vm._v("Gerenciar fornecedores favoritos")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }